<script setup lang="ts">
defineProps({
  slice: {
    type: Object,
    default: () => ({}),
  },
})

defineSlice({
  deprecated: true,
  name: { label: 'Grid Container', group: 'Glue', layouts: ['*'] },
  preview: 'SlicesGlueContainersGridContainer.jpg',
  slots: [{ name: 'default' }],
  description: 'X by X grid container',
  templates: [{
    label: 'Grid Container',
    fields: { columns: { value: '2' }, gap: { value: 4 } },
  }],
})
</script>

<template>
  <div class="relative px-8">
    <div
      class="container mx-auto lg:gap-16"
      :class="{
        'grid grid-cols-1 gap-y-16 lg:grid-cols-12 ': slice.elements.length >= 3,
        'flex flex-col lg:flex-row justify-center': slice.elements.length < 3,
      }"
    >
      <div
        v-for="element in slice.elements" :key="element.id" class="lg:col-span-4 xl:cols-span-3 flex-none" :class="{
          'w-full lg:w-1/3': slice.elements.length < 3,
        }"
      >
        <VoixSlice :slice="element" />
      </div>
    </div>
  </div>
</template>
